import { render } from "./VentasDetalleCajas.vue?vue&type=template&id=759419a3&scoped=true"
import script from "./VentasDetalleCajas.vue?vue&type=script&lang=js"
export * from "./VentasDetalleCajas.vue?vue&type=script&lang=js"

import "./VentasDetalleCajas.vue?vue&type=style&index=0&id=759419a3&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759419a3"]])

export default __exports__